export const LEAVE_REQUEST_PERMISSION_CODES = {
    WEB_LEAVE_REQUEST_LIST: 'WEB_LEAVE_REQUEST_LIST',
    WEB_LEAVE_REQUEST_DETAIL: 'WEB_LEAVE_REQUEST_DETAIL',
    WEB_LEAVE_REQUEST_ADD: 'WEB_LEAVE_REQUEST_ADD',
    WEB_LEAVE_REQUEST_EDIT: 'WEB_LEAVE_REQUEST_EDIT',
    WEB_LEAVE_REQUEST_DELETE: 'WEB_LEAVE_REQUEST_DELETE',
    WEB_LEAVE_REQUEST_IMPORT: 'WEB_LEAVE_REQUEST_IMPORT',
    WEB_LEAVE_REQUEST_EXPORT: 'WEB_LEAVE_REQUEST_EXPORT',
} as const;

